module.exports = __webpack_public_path__ + "static/media/mobile_background.4cd651a5.svg";